const INITIAL_STATE = {
	aguardando: false,
	listaSaldo: [],
	listaViagem: []
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {

		case 'DASHBOARD_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

		case 'DASHBOARD_SALDO_LISTADO':
            return {
				...state,
				listaSaldo: action.payload.data
			};
		case 'DASHBOARD_EMBALAGEM_VIAGEM_LISTADO':
			return {
				...state,
				listaViagem: action.payload.data
			};

        default:
            return state;
    }
}
